import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/01_Navbar';
import Home from './pages/01_Home';
import About from './pages/02_About';
import WorkExperience from './pages/03_WorkExperience';
import Projects from './pages/04_Projects';
import Contact from './pages/05_Contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/02_about" element={<About />} />
        <Route path="/03_work-experience" element={<WorkExperience />} />
        <Route path="/04_projects" element={<Projects />} />
        <Route path="/05_contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
